import { Badge } from 'slab'

import {
  type DentalPlan,
  type NonMedicalPlanFeature,
  type OnboardingEnrollment,
  type PlanCardBadgeCategory,
  type VisionPlan,
} from '../types'
import MemberOnboardingPlanCard from './MemberOnboardingPlanCard'
import { PlanCard } from './PlanCard'
import type { PlanCardFeatureProps } from './PlanCard/Features'
import { PlanChip } from './PlanChip'

const getFeaturesMetadata = (
  features: NonMedicalPlanFeature
): PlanCardFeatureProps => {
  if (features.header === 'Deductibles and limits') {
    const formattedDescription = (
      <ul>
        {features.descriptions.map((item) => (
          <li key={item} className='text-gray-800 body-bold'>
            {item}
          </li>
        ))}
      </ul>
    )
    return {
      term: features.header,
      detail: formattedDescription,
    }
  } else if (features.descriptions.length === 2) {
    return {
      term: features.descriptions[1],
      detail: features.descriptions[0],
    }
  }

  return {
    term: features.header,
    detail: features.descriptions[0],
  }
}

const DentalPlanCard = ({
  badgeCategory,
  displayedPlan,
  onSelectPlan,
  currentPlan,
}: {
  badgeCategory?: PlanCardBadgeCategory;
  displayedPlan: DentalPlan;
  onSelectPlan: (plan: DentalPlan | VisionPlan) => void;
  currentPlan: OnboardingEnrollment | null;
}) => {
  const sidebar = (
    <div className='flex flex-col items-start gap-2 w-36 min-w-36'>
      <PlanChip
        carrierLogo={displayedPlan.carrier_image_url}
        carrierName={displayedPlan.carrier}
        planName={displayedPlan.name}
      />
      {!displayedPlan.waiting_period && (
        <Badge type='success'>No waiting period</Badge>
      )}
    </div>
  )

  const bodyContent = (
    <PlanCard.Features>
      {displayedPlan.features.map((feature) => {
        const featureMetadata = getFeaturesMetadata(feature)
        return (
          <PlanCard.Feature
            term={featureMetadata.term}
            detail={featureMetadata.detail}
            key={feature.header}
          />
        )
      })}
    </PlanCard.Features>
  )

  return (
    <MemberOnboardingPlanCard
      badgeCategory={badgeCategory}
      displayedPlan={displayedPlan}
      currentPlan={currentPlan}
      onSelectPlan={onSelectPlan}
      sidebar={sidebar}
      bodyContent={bodyContent}
      currentType='dental'
    />
  )
}
export default DentalPlanCard
